var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeAccessLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 270.01 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.36,42.46h-2.45l-3.48-4.94v4.94H0v-7.69H2.83l3.1,3.98v-3.98h2.43v7.69Z",
    fill: "#0a0203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56,39.58h-3.17v2.88h-2.92v-7.69h7.07v1.83h-4.14v1.25h3.17v1.73Z",
    fill: "#0a0203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.16,34.46v-.31h.2s.1,0,.14,.02c.05,.03,.08,.08,.08,.13,0,.14-.13,.16-.24,.16h-.18Zm.95,.97l-.29-.71c.19-.09,.29-.21,.29-.43,0-.16-.06-.3-.2-.39-.12-.08-.28-.1-.42-.1h-.82v1.62h.5v-.62h.15l.24,.62h.56Z",
    fill: "#0a0203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,33.29c-.74,0-1.35,.61-1.35,1.35s.61,1.35,1.35,1.35,1.35-.61,1.35-1.35-.61-1.35-1.35-1.35Zm0,2.88c-.85,0-1.54-.69-1.54-1.54s.69-1.54,1.54-1.54,1.54,.69,1.54,1.54-.69,1.54-1.54,1.54Z",
    fill: "#0a0203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.33,16.95c.06-.66,.49-2.25,.45-1.63-.09,1.21,.36,2.22,1.18,3.23,.59,.78,1.29,1.65,1.89,2.84,.44,.86,1.14,1.96,.94,2.29-.21,.33,.59-.81,.85-1.38,.41-.89,.49-1.47,.59-2.45,.12-1.13-.43-3.76-.11-2.91,.2,.49,2.4,3.44,2.75,5.98,.17,1.21,.23,1.93,0,3.13-.29,1.51-.65,1.96-1.62,3.6-.18,.3,.18-2.13,.24-2.87,.09-.98-.64,1.79-1.2,2.87-.36,.68-.56,1.07-1.01,1.69-.69,.96-2.23,2.54-2.06,2.22,.43-1.05,.36-1.38,.49-1.89,.24-1.12,.22-2.02,.03-3.29-.15-1.02-.68-2.21-.69-2.55-.01-.78-.18,1.04-.32,1.7-.42,2.03-1.41,4.7-1.35,5.13,.03,.17-1.06-.98-1.56-1.74-.88-1.34-1.21-4.08-1.27-3.91-.59,1.04-.37,2.93-.33,3.1,.07,.23-.79-.84-1.15-1.46-1.08-1.89-.79-3.46-.33-5.57,.26-1.27,.59-1.69,.86-3.16,.13-.81-.69-3.39-.17-2.15,.3,.58,1.65,1.8,2.19,2.94,.36,.75,1.05,1.89,1.09,2,.09,.29,.3-.82,.3-1.4,0-.75-.53-2.81-.59-2.97-.09-.26-.14-.84-.09-1.38h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37,12.43c.15,.66,.25,1.03,.49,1.66,.5,1.31,1.43,1.76,1.83,3.1,.15,.49,.22,.77,.26,1.27,.08,.88-.3,2.02-.26,2.26,.06,.38-.44-.9-.79-1.44-.42-.66-.79-.93-1.18-1.6-.5-.86-.76-1.4-.95-2.38-.16-.84-.15-1.34-.06-2.19,.08-.78,.45-2.28,.45-1.96,0,.49,.1,.78,.2,1.27h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.02,5.7H4.09C2.08,5.7,.04,6.95,.04,8.94V30.52c0,1.96,1.65,3.01,4.09,3.03h5.7v-3.89H5.61c-.86,0-1.41-.71-1.41-1.5V11.07c0-.73,.66-1.31,1.31-1.31H27.62c.65,0,1.31,.58,1.31,1.31V28.17c0,.78-.55,1.5-1.41,1.5h-4.22v3.89h5.7c2.45-.03,4.09-1.07,4.09-3.03V8.94c0-1.98-2.04-3.23-4.06-3.23h0Z",
    fill: "#0a0203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.45,39.27l.8-2.23,.8,2.23h-1.6Zm2.66-4.5h-3.16l-3.03,7.69h2.44l.6-1.51h2.61l.56,1.51h3.06l-3.06-7.69h0Z",
    fill: "#0a0203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.64,38.02h.78c.24,0,.47,0,.7-.03,.23-.03,.42-.09,.58-.2,.15-.11,.24-.28,.24-.51-.02-.33-.17-.54-.46-.63s-.61-.12-.97-.12h-.87v1.49Zm0,1.65v2.79h-3.03v-7.69h3.99c.48,0,.97,.01,1.47,.06,.5,.05,.96,.16,1.39,.35,.46,.22,.82,.5,1.07,.86,.25,.35,.38,.74,.38,1.16,0,.37-.09,.72-.27,1.04-.18,.33-.45,.61-.81,.84-.38,.23-.8,.4-1.26,.48-.46,.08-.93,.12-1.4,.12h-1.53Z",
    fill: "#0a0203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.18,0V50",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.25,11.52h16.3v5.81h-9.36v5.62h6.64v5.43h-6.64v10.68h-6.94V11.52h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24,11.52h8.99c6.04,0,9.85,2.46,9.85,9.08,0,3.42-1.57,6.07-4.18,7.3l5.03,11.17h-7.16l-4.25-9.38h-1.53v9.38h-6.75V11.52h0Zm8.8,12.95c2.31,0,3.43-1.01,3.43-3.72s-1.12-3.5-3.43-3.5h-2.05v7.22h2.05Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.07,11.52h16.67v5.81h-9.73v4.8h6.93v5.43h-6.93v5.88h10.18v5.62h-17.12V11.52h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29,11.52h16.67v5.81h-9.74v4.8h6.94v5.43h-6.94v5.88h10.18v5.62h-17.12V11.52h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04,39.07h-6.45l8.06-27.66h6.75l8.05,27.66h-6.97l-1.16-4.65h-7.09l-1.19,4.65h0Zm6.49-12.06c-.67-2.72-1.23-4.5-1.64-7.04h-.07c-.41,2.57-1.01,4.28-1.72,7.04l-.52,2.09h4.44l-.48-2.09h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6,25.3c0-10.16,4.7-14.3,11.19-14.3s9.06,3.76,9.81,9.87l-6.52,1.16c-.52-3.54-1.31-5.14-3.51-5.14-2.83,0-3.99,2.79-3.99,8.41s1.23,8.6,4.06,8.6c2.24,0,3.13-1.45,3.73-5.51l6.53,1.04c-.97,5.66-3.54,10.13-10.29,10.13s-11-4.09-11-14.26h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,25.3c0-10.16,4.7-14.3,11.19-14.3s9.06,3.76,9.81,9.87l-6.53,1.16c-.52-3.54-1.31-5.14-3.51-5.14-2.83,0-3.99,2.79-3.99,8.41s1.23,8.6,4.07,8.6c2.24,0,3.13-1.45,3.73-5.51l6.52,1.04c-.97,5.66-3.54,10.13-10.29,10.13s-11-4.09-11-14.26h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9,11.52h16.67v5.81h-9.73v4.8h6.93v5.43h-6.93v5.88h10.18v5.62h-17.12V11.52h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.7,32.97l5.56-2.83c1.16,2.05,2.98,3.98,5.41,3.98,1.94,0,2.91-.93,2.91-2.38,0-1.83-2.05-2.68-4.51-3.65-3.69-1.49-8.35-3.2-8.35-9.01,0-4.88,3.95-8.08,9.4-8.08,4.92,0,7.98,2.64,9.81,6.33l-5.33,2.94c-1.19-2.31-2.65-3.61-4.62-3.61-1.64,0-2.46,.89-2.46,2.09,0,1.68,1.79,2.57,4.06,3.54,3.77,1.57,8.8,3.31,8.8,9.16,0,4.24-3.21,8.15-9.7,8.15-5.82,0-9.03-2.79-10.97-6.63h0Z",
    fill: "#ed1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34,32.97l5.56-2.83c1.16,2.05,2.98,3.98,5.41,3.98,1.94,0,2.91-.93,2.91-2.38,0-1.83-2.05-2.68-4.51-3.65-3.69-1.49-8.35-3.2-8.35-9.01,0-4.88,3.95-8.08,9.4-8.08,4.92,0,7.98,2.64,9.81,6.33l-5.33,2.94c-1.19-2.31-2.65-3.61-4.62-3.61-1.64,0-2.46,.89-2.46,2.09,0,1.68,1.79,2.57,4.06,3.54,3.77,1.57,8.8,3.31,8.8,9.16,0,4.24-3.21,8.15-9.7,8.15-5.82,0-9.03-2.79-10.97-6.63h0Z",
    fill: "#ed1944"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeAccessLogo);
export default __webpack_public_path__ + "static/media/free-access-logo.0c4549b80dcb418a89675ad6af848e1e.svg";
export { ForwardRef as ReactComponent };